import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "吃菜/做菜统计目录", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-muted mb-4" }, "选择包含吃菜/做菜套系的目录，排名统计只计算选中目录", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("保存")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, { "label-width": "140px" }, {
      default: _withCtx(() => [
        _hoisted_2,
        _hoisted_3,
        _createVNode(_component_el_form_item, { label: "统计目录" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _ctx.selectedCategories,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedCategories) = $event)),
              multiple: "",
              clearable: "",
              placeholder: "选择目录",
              style: {"width":"400px"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (cat) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: cat.id,
                    label: cat.name,
                    value: cat.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.onSave,
              loading: _ctx.saving
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["onClick", "loading"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}